// React
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useTheme } from "@mui/material/styles"

// Hooks and Redux
import { ThemeProvider } from "@mui/material/styles"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Grid"
import TextField from "@mui/material/TextField"
import FormControl from "@mui/material/FormControl"
import CircularProgress from "@mui/material/CircularProgress"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import DialogActions from "@mui/material/DialogActions"
import Dialog from "@mui/material/Dialog"

// Utils
// import newAdapter from "../../../utils/newAdapter"
// import dayjs, { Dayjs } from "dayjs"
import { useTranslation } from "react-i18next"
// import Swal from "sweetalert2"
import jwtDecode from "jwt-decode"
import { useForm } from "react-hook-form"

// Styles
import { green } from "@mui/material/colors"
import theme from "../../../styles/theme"
import Swal from "sweetalert2"

// Services
import {
  getAllEmploymentContract,
  addContractData,
} from "../../../services/EmployeeContractService"
import { getActiveEmployer } from "../../../services/EmpService"

import { Autocomplete } from "@mui/material"
import match from "autosuggest-highlight/match"
import parse from "autosuggest-highlight/parse"

// Types
import { TokenPayload, ECData as ECDataType } from "../../../@types"

export interface InputDataToECProps {
  ec_Ids: any
  data: ECDataType[]
  typeEC: string
  keepMounted: boolean
  open: boolean
  onClose: (value?: boolean) => void
}

interface IContract {
  id: string
  name: string
  nameFile: string
  type: string
  dmsFileId: string
  is_active: boolean
  modified_by?: string
  modified_date?: string
  created_by?: string
  created_date?: string
}

export default function SelectContract(props: InputDataToECProps) {
  const { ec_Ids, typeEC, data, onClose, open, ...other } = props
  const navigate = useNavigate()
  const { t } = useTranslation()
  const themeUI = useTheme()

  const token = localStorage.getItem("access_token") || ""
  const decoded: TokenPayload = jwtDecode(token)
  // const [loadingECData, setLoadingECData] = useState<boolean>(true)
  const [submittedLoading, setSubmittedLoading] = useState<boolean>(false)
  // const [prefixList, setPrefixList] = useState<any>([])
  // const [rowsECData, setRowsECData] = useState<any>()

  const [contractList, setContractList] = useState<any | null>([])
  const [employersList, setEmployersList] = useState<any | null>([])

  const [selectedContract, setSelectedContract] = useState<string>("")
  const [selectedEmployers, setSelectedEmployers] = useState<string>("")

  const [positionValue, setPositionValue] = useState<string>("")
  const [loadingContractList, setLoadingContractList] = useState<boolean>(true)

  const allSuccessLoading = !loadingContractList

  const {
    register,
    // setValue,
    handleSubmit,
    formState: { errors },
  } = useForm()

  useEffect(() => {
    const fetchAllEmploymentContract = async () => {
      try {
        const response = await getAllEmploymentContract("Active")

        if (response?.data?.success) {
          setContractList(response?.data?.data)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      } finally {
        setLoadingContractList(false)
      }
    }

    const fetchEmployers = async () => {
      try {
        const response = await getActiveEmployer()
        if (response.data?.success) {
          const dataEmp = response?.data?.users

          setEmployersList(dataEmp)
        }
      } catch (error) {
        navigate("/servererror", { replace: true })
      }
    }

    if (open) {
      fetchAllEmploymentContract()
      fetchEmployers()
    }
  }, [navigate, open])

  const GetFileDateTime = async (date: Date) => {
    const pad = function (num: number) {
      return (num < 10 ? "0" : "") + num
    }

    return (
      date.getFullYear() +
      "" +
      pad(date.getMonth() + 1) +
      "" +
      pad(date.getDate()) +
      "_" +
      pad(date.getHours()) +
      "" +
      pad(date.getMinutes()) +
      "" +
      pad(date.getSeconds())
    )
  }

  const onSubmitted = async () => {
    try {
      setSubmittedLoading(true)
      const contractData: IContract = contractList?.find(
        (item: IContract) => item?.id === selectedContract
      )
      const userECData = data
        .filter((item: ECDataType) => ec_Ids.includes(item.id))
        .map((j: any) => ({
          id: j.id,
          user_id: typeEC === "DataEC" ? j?.AppFormStatus?.user_id : j?.user_id,
          hiring_date: j.hire_date,
        }))

      const reqData = {
        contractId: contractData?.id,
        data: userECData, //id and userId
        typeEC: typeEC,
        dmsFileId: contractData?.dmsFileId,
        created_by: decoded.Username,
        positionName: positionValue,
        nameFile: contractData?.nameFile,
        employerId: selectedEmployers,
        //  `${contractData?.nameFile}
        //  _${await GetFileDateTime(
        //    new Date(userECData.hiring_date)
        //  )}
        // `,
      }
      const respData = await addContractData(reqData)
      if (respData?.data?.status === 200) {
        onClose(true)
        setSubmittedLoading(false)
        Swal.fire({
          icon: "success",
          title: `${t("Success")}`,
          text: `${t("text_add_success_employee_contract")}`,
          confirmButtonText: `${t("ok")}`,
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload()
          }
        })
      } else {
        setSubmittedLoading(false)
        onClose(true)

        Swal.fire({
          icon: "error",
          title: `${t("Error")}`,
          text: `${t("text_add_failed_employee_contract")} [${
            respData?.data?.message
          }]`,
          confirmButtonText: `${t("ok")}`,
        })
      }
    } catch (error) {
      console.log(error)
      setSubmittedLoading(false)
      onClose(true)
      Swal.fire({
        icon: "error",
        title: `${t("Error")}`,
        text: `${t("Please try again")}`,
        confirmButtonText: `${t("ok")}`,
      })
    }
  }

  const getEmployerDisplayName = (employer: any) =>
    `${employer.first_name_th} ${employer.last_name_th}`

  return (
    <ThemeProvider theme={theme}>
      <Dialog
        sx={{
          "& .MuiDialog-paper": {
            width: "80%",
            height: "60%",
            position: "relative",
            padding: themeUI.spacing(2),

            [themeUI.breakpoints.up("md")]: {
              width: "50%",
              height: "60%",
            },
            [themeUI.breakpoints.up("lg")]: {
              width: "30%",
              height: "60%",
            },
          },
        }}
        open={open}
        {...other}
      >
        {!allSuccessLoading ? (
          <>
            <DialogContent sx={{ height: "30vh" }}>
              <CircularProgress
                size={50}
                sx={{
                  color: green[500],
                  position: "absolute",
                  zIndex: 999,
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              />
            </DialogContent>
          </>
        ) : (
          <>
            <DialogTitle
              id="scroll-dialog-title"
              sx={{ fontWeight: "bold", fontSize: { xs: 16, sm: 18 } }}
            >
              {t("text_select_employee_contract")}
            </DialogTitle>

            <DialogContent
              dividers
              sx={{ display: "flex", flexDirection: "column" }}
            >
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <Box sx={{ marginBottom: 2 }}>
                    <Autocomplete
                      onChange={(
                        event,
                        newValue: {
                          id: string
                          nameFile: string
                        } | null
                      ) => {
                        setSelectedContract(newValue?.id || "")
                      }}
                      options={contractList}
                      getOptionLabel={(option) => option.nameFile}
                      value={
                        contractList.filter(
                          (item: any) => item.id === selectedContract
                        )[0]
                      }
                      renderOption={(
                        props,
                        option,
                        { inputValue, selected }
                      ) => {
                        const matches = match(option.nameFile, inputValue, {
                          insideWords: true,
                        })
                        const parts = parse(option.nameFile, matches)

                        return (
                          <li {...props}>
                            <div>
                              {parts.map((part: any, index: any) => (
                                <span
                                  key={index}
                                  style={{
                                    fontWeight: part.highlight ? 700 : 400,
                                  }}
                                >
                                  {part.text}
                                </span>
                              ))}
                            </div>
                          </li>
                        )
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder={
                            t("text_employee_employee_contract") + " *"
                          }
                          label={t("text_employee_employee_contract") + " *"}
                          error={errors.company ? true : false}
                          {...register("EmployeeContract", {
                            required: true,
                          })}
                        />
                      )}
                    />
                  </Box>
                  <Box sx={{ marginBottom: 2 }}>
                    <Autocomplete
                      onChange={(
                        event,
                        newValue: {
                          id: string
                          first_name_th: string
                        } | null
                      ) => {
                        setSelectedEmployers(newValue?.id || "")
                      }}
                      options={employersList}
                      getOptionLabel={(option) =>
                        getEmployerDisplayName(option)
                      }
                      value={
                        employersList.filter(
                          (item: any) => item.id === selectedEmployers
                        )[0]
                      }
                      renderOption={(
                        props,
                        option,
                        { inputValue, selected }
                      ) => {
                        const displayName = getEmployerDisplayName(option)
                        const matches = match(displayName, inputValue, {
                          insideWords: true,
                        })
                        const parts = parse(
                          getEmployerDisplayName(option),
                          matches
                        )

                        return (
                          <li {...props}>
                            <div>
                              {parts.map((part: any, index: any) => (
                                <span
                                  key={index}
                                  style={{
                                    fontWeight: part.highlight ? 700 : 400,
                                  }}
                                >
                                  {part.text}
                                </span>
                              ))}
                            </div>
                          </li>
                        )
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder={t("text_employee_name_employers") + " *"}
                          label={t("text_employee_name_employers") + " *"}
                          error={errors.company ? true : false}
                          {...register("Employers", {
                            required: true,
                          })}
                        />
                      )}
                    />
                  </Box>
                  <TextField
                    fullWidth
                    id="Position"
                    label={t("text_employee_name_position")}
                    placeholder={t("text_employee_name_position")!}
                    value={positionValue}
                    required
                    onChange={(event) => {
                      setPositionValue(event.target.value)
                    }}
                  />
                </FormControl>
                {errors.EmployeeContract?.type === "required" && (
                  <Typography
                    variant="inherit"
                    color="error"
                    align="left"
                    pt={1}
                    ml={1}
                    fontSize={13}
                  >
                    {t("Position is require")}
                  </Typography>
                )}
              </Grid>
            </DialogContent>
            <DialogActions
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                px: 3,
                py: 2,
              }}
            >
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button
                  color="error"
                  variant="contained"
                  onClick={() => {
                    onClose()
                    setSubmittedLoading(false)
                    // setLoadingECData(true)
                  }}
                  sx={{ px: 3 }}
                >
                  {t("Cancel")}
                </Button>
              </Box>

              <Button
                variant="contained"
                color="primary"
                // onClick={handleClick}
                onClick={handleSubmit(onSubmitted)}
                sx={{ px: 3 }}
                disabled={submittedLoading}
              >
                {t("Confirm")}
                {submittedLoading && (
                  <CircularProgress
                    size={24}
                    sx={{
                      color: green[500],
                      position: "absolute",
                      zIndex: 999,
                    }}
                  />
                )}
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </ThemeProvider>
  )
}
